// extracted by mini-css-extract-plugin
export default {"RubriqueNavigation":"RubriqueNavigationAdmin_RubriqueNavigation__mViWI","active":"RubriqueNavigationAdmin_active__0H8p6"};